<div
  class="in-app-banner horizontal-focusable-container vertical-as"
  [ngClass]="'horizontal-carousel-cards-' + verticalIndex"
>
  <img
    [src]="resource?.providerImage"
    alt="in-app-banner"
    class="focusable-element in-app-banner-image"
    [tabindex]="index"
    [class]="getClassName()"
    (focus)="onFocus()"
    (click)="onClick()"
    loading="lazy"
    [class.loaded]="imageLoaded"
    (load)="onImageLoad()"
    [style.width]="getImageWidth()"
    [style.height]="getImageHeight()"
  />
  <div *ngIf="!imageLoaded" class="image-placeholder"></div>
</div>
